import { CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';

export const LoadingDialog = () => {
    const [open, setOpen] = React.useState(true);

    const handleClose = (_, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    };
  
    return (
      <div >
        <Dialog 
          open={open}
          onClose={handleClose}
          disableEscapeKeyDown
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description" 
        >
          <DialogTitle id="alert-dialog-title" >
            {"Cargando información..."}
          </DialogTitle>
          <DialogContent sx={{
                        margin: 2,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}>
              <CircularProgress />
          </DialogContent>
        </Dialog>
      </div>
    );
};

//sx={{ bgcolor: 'primary.main' }}